import { render } from "./object-help-in-person.vue?vue&type=template&id=3c5c2985"
import script from "./object-help-in-person.vue?vue&type=script&lang=js"
export * from "./object-help-in-person.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__